import { createElement, selectOne } from 'vevet-dom';
import { Component } from '../../../base/Component';
import { SmoothScroll } from '../smooth-scroll/SmoothScroll';
import Bar from './Bar';
/**
 * Create custom scroll bar
 */
export class ScrollBar extends Component {
    constructor(initialProp, init = true) {
        super(initialProp, false);
        const { autoHide, autoSize, minSize, optimizeCalculations, isDraggable, draggableScrollBehavior, } = this.prop;
        // get container
        if (typeof this.prop.container === 'string') {
            const el = selectOne(this.prop.container);
            if (el) {
                this._container = el;
            }
            else {
                throw new Error('No scroll container');
            }
        }
        else {
            this._container = this.prop.container;
        }
        // create scrollBarsParent if needed
        if (this.container instanceof Element) {
            const { parentElement } = this.container;
            if (parentElement) {
                this._scrollWrapper = createElement('div');
                this._scrollWrapper.style.position = 'relative';
                this._scrollWrapper.style.display = 'inline-block';
                parentElement.insertBefore(this._scrollWrapper, this.container);
                this._scrollWrapper.appendChild(this.container);
                this._scrollWrapper.classList.add(`${this.prefix}-wrapper`);
            }
        }
        // create bars
        const barMainProp = {
            container: this.container,
            domParent: this.domParent,
            autoHide,
            autoSize,
            minSize,
            optimizeCalculations,
            prefix: this.prefix,
            isDraggable,
            draggableScrollBehavior,
        };
        this._xBar = new Bar(Object.assign({ dir: 'x' }, barMainProp));
        this._yBar = new Bar(Object.assign({ dir: 'y' }, barMainProp));
        // add styles
        this.scrollableElement.classList.add(`${this.prefix}-parent`);
        // initialize the class
        if (init) {
            this.init();
        }
    }
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { container: window, domParent: false, draggable: true, autoSize: true, autoHide: true, minSize: 50, optimizeCalculations: false, resizeTimeout: 0, isDraggable: true, draggableScrollBehavior: 'smooth' });
    }
    get prefix() {
        return `${this._app.prefix}scrollbar`;
    }
    /**
     * Scroll container
     */
    get container() {
        return this._container;
    }
    /**
     * Get scrollable element
     */
    get scrollableElement() {
        const { container } = this;
        if (container instanceof Window) {
            return this._app.body;
        }
        if (container instanceof Element) {
            return container;
        }
        return container.outer;
    }
    /**
     * The element into wchich scroll bars will be appended
     */
    get domParent() {
        const { domParent } = this.prop;
        const { container } = this;
        if (!domParent) {
            if (this._scrollWrapper) {
                return this._scrollWrapper;
            }
            if (container instanceof Window) {
                return this._app.body;
            }
            if (container instanceof Element) {
                return container;
            }
            return container.outer;
        }
        return domParent;
    }
    // Set Module Events
    _setEvents() {
        super._setEvents();
        const { container } = this;
        // set resize event
        if (container instanceof SmoothScroll) {
            container.addCallback('resize', () => {
                this.resize();
            }, {
                name: this.name,
            });
        }
        else {
            this.addViewportCallback('', () => {
                this.resize();
            }, {
                timeout: this.prop.resizeTimeout,
            });
        }
        this.resize();
    }
    _onPropMutate() {
        super._onPropMutate();
        this.resize();
    }
    /**
     * Resize the canvas
     */
    resize() {
        this._xBar.resize();
        this._yBar.resize();
    }
    /**
     * Destroy the module
     */
    _destroy() {
        super._destroy();
        // destroy bars
        this._xBar.destroy();
        this._yBar.destroy();
        // remove scrollbars parent
        if (!!this._scrollWrapper && this.container instanceof Element) {
            const { parentElement } = this._scrollWrapper;
            if (parentElement) {
                parentElement.insertBefore(this.container, this._scrollWrapper);
            }
            this._scrollWrapper.remove();
        }
        // reset styles
        this.scrollableElement.classList.remove(`${this.prefix}-parent`);
    }
}
